import React, { useEffect, useState } from "react"
import * as BabyMenuStyles from "./BabyMenu.module.scss"
import Button from "../../../../lib/common/blocks/button/Button"
import Icon from "../../../../lib/common/blocks/icon/Icon"
import Section from "../../main/section/Section"
import MegaMenuProductCategoriesTree from "./mega-menu/mega-menu-product-categories-tree/MegaMenuProductCategoriesTree"
import MegaMenuJobAds from "./mega-menu/mega-menu-job-ads-data/MegaMenuJobAds"
import MegaMenuSectorsList from "./mega-menu/mega-menu-sectors-list/MegaMenuSectorsList"
import MegaMenuPagesSelection from "./mega-menu/mega-menu-pages-selection/MegaMenuPagesSelection"
import MegaMenuSearch from "./mega-menu/mega-menu-search/MegaMenuSearch"
import { isMobileDevice } from "../../../../../utils/isDevice"
import BabyMenuSearchForm from "./baby-menu-search-form/BabyMenuSearchForm"
import Image from "../../../../lib/common/blocks/image/Image"

const { sites } = require("../../../../../utils/site")

const BabyMenu = ({
  site,
  siteData,
  sectorsData,
  jobAdsData,
  productCategoriesTree,
  gcProductCategoriesTree,
  ismenuactive,
  triggerParentUpdate,
  searchTerm,
  triggerParentUpdateSearchTerm,
}) => {
  const menuData = siteData?.attributes?.babyMenu
  const logoData = siteData?.attributes?.logo
  const babyMenuButtonText = siteData?.attributes?.buttonRdvText

  const [isMegaMenuActive, setMegaMenuActive] = useState({})

  const handleButtonClick = (index) => {
    if (isMobileDevice()) {
      setMegaMenuActive((isMegaMenuActive) => ({
        ...isMegaMenuActive,
        [index]: !isMegaMenuActive[index],
      }))
    }
  }
  const isChildOfCategory = (category, id) => {
    if (category.id === id) {
      return category
    }
    if (category.children) {
      for (const cat of category.children) {
        const found = isChildOfCategory(cat, id)
        if (found) {
          return found
        }
      }
    }
    return null
  }
  const renderColItems = (data) => {
    return data?.map((item, index) => {
      let data = []
      let card = item.card
      let name = item.label
      let comp
      switch (item.__typename) {
        case "Strapi_ComponentABabyMenuBmGcProductCategory":
          data = isChildOfCategory(
            { id: 0, children: gcProductCategoriesTree },
            item.gc_product_category?.data?.id
          )
          if (!data) {
            throw new Error("Aucune catégorie de produit trouvée")
          }
          ;(data.children || data.products) &&
            (comp = (
              <MegaMenuProductCategoriesTree
                name={name}
                megaMenuData={data}
                card={card}
                isMegaMenuActive={isMegaMenuActive[index]}
                triggerParentUpdate={() => handleButtonClick(index)}
              />
            ))
          break
        case "Strapi_ComponentABabyMenuBmProductCategory":
          data = isChildOfCategory(
            { id: 0, children: productCategoriesTree },
            item.product_category?.data?.id
          )
          if (!data) {
            throw new Error("Aucune catégorie de produit trouvée")
          }
          ;(data.children || data.products) &&
            (comp = (
              <MegaMenuProductCategoriesTree
                name={name}
                megaMenuData={data}
                card={card}
                isMegaMenuActive={isMegaMenuActive[index]}
                triggerParentUpdate={() => handleButtonClick(index)}
              />
            ))
          break
        case "Strapi_ComponentABabyMenuBmPagesSelection":
          data = item.pages.data
          comp = (
            <MegaMenuPagesSelection
              name={name}
              megaMenuData={data}
              card={card}
              isMegaMenuActive={isMegaMenuActive[index]}
              triggerParentUpdate={() => handleButtonClick(index)}
            />
          )
          break
        case "Strapi_ComponentABabyMenuBmSectorList":
          data = sectorsData.sort((a, b) =>
            a.attributes.menuPriority < b.attributes.menuPriority ? 1 : -1
          )
          comp = (
            <MegaMenuSectorsList
              name={name}
              megaMenuData={data}
              card={card}
              isMegaMenuActive={isMegaMenuActive[index]}
              triggerParentUpdate={() => handleButtonClick(index)}
            />
          )
          break
        case "Strapi_ComponentABabyMenuBmLastJobAds":
          data = jobAdsData
          comp = (
            <MegaMenuJobAds
              name={name}
              megaMenuData={data}
              card={card}
              isMegaMenuActive={isMegaMenuActive[index]}
              triggerParentUpdate={() => handleButtonClick(index)}
            />
          )
          break
        case "Strapi_ComponentABabyMenuBmCategoryList":
        case "Strapi_ComponentABabyMenuBmNoMegaMenu":
        default:
          card = []
          comp = null
          data = []
      }
      const { label } = item
      const route =
        item.itemMenuCtaLink ||
        item.ItemMenuCtaLink ||
        item.product_category?.data?.attributes.autoRoute ||
        item.gc_product_category?.data?.attributes.autoRoute
      return (
        <li key={index}>
          <Button
            aspect="unstyled"
            color="unstyled"
            ctalink={route}
            onClick={!route ? () => handleButtonClick(index) : undefined}
            activeclassname={BabyMenuStyles.active}
          >
            <span>{label}</span>
          </Button>
          {comp && (
            <Button
              aspect="unstyled"
              color="unstyled"
              className="xs-flex lg-none ml-auto"
              onClick={() => handleButtonClick(index)}
            >
              <Icon
                icon="arrowRight"
                color="var(--secondary-color)"
              />
            </Button>
          )}
          {comp}
        </li>
      )
    })
  }

  const [modifiedNumber, setModifiedNumber] = useState(null)
  useEffect(() => {
    if (window.dexem_dni_ad27dd9ec69f4daca11541d1d4da1ce8) {
      window.dexem_dni_ad27dd9ec69f4daca11541d1d4da1ce8.init()
      const firstEntry = Object.values(
        window.dexem_dni_ad27dd9ec69f4daca11541d1d4da1ce8?.swapped_numbers
      )[0]
      setModifiedNumber(firstEntry?.national)
    }
  }, [])
  useEffect(() => {}, [modifiedNumber])
  const phoneNumber = siteData?.attributes?.phoneNumber

  const renderlastColItem = () => {
    switch (site) {
      case "gc":
      case "com":
      case "lp":
        return (
          <>
            <li
              className={`${BabyMenuStyles.lastColItem} ${BabyMenuStyles.buttons}`}
            >
              <div className={BabyMenuStyles.buttonsContainer}>
                <Button
                  aspect="classique"
                  color="primary"
                  size="large"
           
                  ctalink={{
                    type: "site",
                    site: site,
                    subType: "collection",
                    collectionName: "pop-ins",
                    itemId: "16",
                    popIn: undefined,
                    context1: "baby-menu",
                    itemData: {
                      attributes: { autoRoute: "/pop-in/rendez-vous-1" },
                    },
                  }}
                  asModal
                >
                  {/* <Image
                    imgSrc="https://media.paritel.fr/paritel-www-dev/assets/rdvvisio_51c38e889e.svg"
                    imgAlt="Rdv visio"
                    imgWidth="23"
                    imgHeight="22"
                    loading="lazy"
                  /> */}
                  {babyMenuButtonText}
                </Button>
                <Button
                  aspect="contrastant"
                  color="primary"
                  size="medium"

                  href={`tel:${modifiedNumber ? modifiedNumber : phoneNumber}`}
                  // href={`tel:0189617044`}
                >
                  <Image
                    imgSrc="https://media.paritel.fr/paritel-www-dev/assets/telephone_blanc_e34f546779.svg"
                    imgAlt="Téléphone"
                    imgWidth="22"
                    imgHeight="21"
                    loading="lazy"
                    style={{ margin: "0" }}
                  />
                  {modifiedNumber ? modifiedNumber : phoneNumber}
                  {/* 01 89 61 70 44 */}
                </Button>
              </div>
            </li>
            <li className={BabyMenuStyles.searchMobile}>
              <BabyMenuSearchForm
                searchTerm={searchTerm}
                triggerParentUpdateSearchTerm={triggerParentUpdateSearchTerm}
                site={site}
              />
            </li>
            <li
              className={`buttons ${BabyMenuStyles.toggleSwitchButtonsContainer}`}
            >
              <Button
                aspect={"unstyled"}
                href={sites["com"].baseUrl}
                className={`${BabyMenuStyles.toggleSwitchButton} ${
                  site === "com" ? BabyMenuStyles.active : ""
                }`}
              >
                Professionnel
              </Button>
              <Button
                aspect={"unstyled"}
                href={sites["gc"].baseUrl}
                className={`${BabyMenuStyles.toggleSwitchButton} ${
                  site === "gc" ? BabyMenuStyles.active : ""
                }`}
              >
                Entreprise
              </Button>
            </li>
          </>
        )
      case "sl":
        return (
          <li
            className={`${BabyMenuStyles.lastColItem} ${BabyMenuStyles.agences}`}
          >
            <div className={BabyMenuStyles.buttonsContainer}>
              <Button
                aspect="contrastant"
                color="primary"
                size="medium"
                ctalink="/"
              >
                <Image
                  imgSrc="https://media.paritel.fr/paritel-www-dev/assets/marker_blanc_7f5b1c5bf8.svg"
                  imgAlt="marker blanc"
                  imgWidth="22"
                  imgHeight="21"
                  loading="lazy"
                />
                Trouver mon agence
              </Button>
            </div>
          </li>
        )
      case "grp":
      case "rh":
      case "blog":
      default:
        return (
          <li
            className={`${BabyMenuStyles.lastColItem} ${BabyMenuStyles.search}`}
          >
            <BabyMenuSearchForm
              searchTerm={searchTerm}
              triggerParentUpdateSearchTerm={triggerParentUpdateSearchTerm}
              site={site}
            />
            <MegaMenuSearch
              term={searchTerm}
              name={"search"}
            />
          </li>
        )
    }
  }

  return (
    <Section
      className={BabyMenuStyles.babymenu}
      container="xxlarge pl-lg-8 pr-lg-3 flex align-items-center justify-content-space-between relative"
    >
      <Button
        aspect="unstyled"
        color="unstyled"
        ctalink="/"
        className={BabyMenuStyles.logoLink}
      >
        <Image
          imgSrc={logoData?.data?.attributes?.url}
          imgAlt={logoData?.data?.attributes?.alternativeText}
          imgWidth={logoData?.data?.attributes?.width}
          imgHeight={logoData?.data?.attributes?.height}
        />
      </Button>
      <nav
        className={
          ismenuactive
            ? `${BabyMenuStyles.menu} ${BabyMenuStyles.active}`
            : BabyMenuStyles.menu
        }
      >
        <ul>
          {renderColItems(menuData)}
          {renderlastColItem()}
        </ul>
      </nav>
      <Button
        aspect="unstyled"
        color="unstyled"
        size="large"
        className={
          ismenuactive
            ? `${BabyMenuStyles.burger} ${BabyMenuStyles.active}`
            : BabyMenuStyles.burger
        }
        onClick={() => triggerParentUpdate(!ismenuactive)}
      >
        <span>&nbsp;</span>
      </Button>
    </Section>
  )
}

export default BabyMenu
